import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/childcare-cost-calculator',
  component: () => import('../../routes/ChildcareCostCalculator.svelte'),
  card: {
    id: 'childcare-cost-calculator',
    title: 'Childcare Cost Calculator',
    description:
      'Calculate the total cost of childcare from birth through school age, including inflation and present value.',
    icon: 'child_care',
    iconBgClass: 'bg-purple-50',
    iconTextClass: 'text-purple-600',
    href: '/childcare-cost-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Childcare Cost Calculator – Plan Your Childcare Budget',
    description:
      'Calculate the total cost of childcare over multiple years. See annual costs, inflation-adjusted projections, and present value of your childcare expenses.',
  },
};

export default meta;
